<app-field-editor-map-edit-control
  id="editControl"
  [mapReady]="mapReady$"
  [editEvent]="editFieldSubject"
  (editDone)="fieldEditDone($event)"
></app-field-editor-map-edit-control>
<app-field-editor-map-field-crop-control
  *ngIf="crop"
  [mapReady]="mapReady"
  [editEvent]="editFieldCropSubject"
  (editDone)="fieldCropEditDone($event)"
></app-field-editor-map-field-crop-control>
<app-map-layers-control
  [mapReady]="mapReady$"
  [layers]="layers"
  (loaded)="mapLayersControlLoaded($event)"
></app-map-layers-control>
<div
  id="field-editor-map"
  class="field-editor-map"
  leaflet
  [leafletOptions]="mapOptions"
  (leafletMapReady)="onMapReady($event)"
></div>

<dx-load-panel
  shadingColor="rgba(0,0,0,0.1)"
  [position]="{ of: host.nativeElement }"
  [visible]="isLoading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [closeOnOutsideClick]="false"
>
</dx-load-panel>
<dx-popover
  class="field-editor-changes-popover"
  [width]="400"
  target="#fieldMapFilter"
  showEvent="dxclick"
  [deferRendering]="false"
  [showTitle]="true"
  [elementAttr]="{ class: 'field-editor-changes-popover' }"
  position="bottom"
  title="Filter Parcelle"
  [container]="container.getElement()"
  [showCloseButton]="true"
  [closeOnOutsideClick]="true"
>
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="top"
    location="after"
    [options]="{
      icon: 'refresh',
      hint: 'Réinitialiser les paramètres du filter',
      onClick: resetFilter,
      stylingMode: 'text'
    }"
  >
  </dxi-toolbar-item>

  <div *dxTemplate="let model of 'content'">
    <dx-form
      id="form"
      [formData]="filter"
      [showValidationSummary]="true"
      (onFieldDataChanged)="filterFieldChange($event)"
    >
      <dxi-item itemType="group" caption="Filters">
        <dxi-item
          dataField="search"
          [editorOptions]="{ placeholder: 'Nom, code, id...' }"
        >
          <dxo-label text="Recherche"></dxo-label>
        </dxi-item>

        <dxi-item dataField="campaign">
          <dxo-label text="Campagne"></dxo-label>
          <div *dxTemplate>
            <app-campaign-selector
              (valueChange)="campaignChange($event)"
              [value]="filter.campaign"
            ></app-campaign-selector>
          </div>
        </dxi-item>

        <dxi-item dataField="domain">
          <dxo-label text="Domaine"></dxo-label>
          <div *dxTemplate>
            <app-user-domains-chooser
              (valueChange)="domainChange($event)"
              [id]="filter.domain"
            ></app-user-domains-chooser>
          </div>
        </dxi-item>
      </dxi-item>

      <dxi-item itemType="group" caption="Paramètres d'affichage">
        <dxi-item
          dataField="fieldTooltip"
          editorType="dxSelectBox"
          [editorOptions]="{
            value: 'Nom',
            items: ['Code', 'Nom', 'Nom (Code)', 'Nom (ID)']
          }"
        >
          <dxo-label text="Info-bulle de parcelle"></dxo-label>
        </dxi-item>
      </dxi-item>
    </dx-form>
  </div>
</dx-popover>
